<template>
  <div id="wizard-frame" class="gate-container">
    <DpplSignupLogoutButton
      v-if="authData.isLoggedIn"
      id="logout-button"
      href="/logout"
      class="mt-6"
    >
      Log Out
    </DpplSignupLogoutButton>
    <div class="main-container">
      <main>
        <AppAlerts />
        <router-view
          v-slot="{ Component }"
          @track-page-load="$emit('track-page-load', $event)"
        >
          <component :is="Component" />
        </router-view>
      </main>
      <footer>
        <p class="text-body-3 text-textDark mb-6">
          All Rights Reserved. Payscale, Inc. @ {{ (new Date()).getFullYear() }}.
        </p>
      </footer>
    </div>
    <div class="right-banner" />
  </div>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import { useAppAuthData } from '@/stores/app/authData';
import AppAlerts from '@/components/shared/alerts/AppAlerts.vue';
import DpplSignupLogoutButton from '@/components/datapeople/DpplSignupLogoutButton.vue';

defineEmits(['track-page-load']);

const { authData } = storeToRefs(useAppAuthData());
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@import '@/less/mixins';

#wizard-frame {
  width: 100%;
  height: 100%;
  max-height: 100vh;
  overflow-y: auto;
  overflow-x: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: @text-darkest;
  background: @white;
  position: relative
}

.gate-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.main-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
}

main {
  width: 100%;
  min-width: 600px;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.right-banner {
  width: 40%;
  min-width: 300px;
  height: 100%;
  background-color: @forest-green;
}

#logout-button {
  position: absolute;
  top: 36px;
  right: 36px;
  width: 157px;
  .shadow();

  :deep(.v-btn__content) {
    color: @text-darkest;
    font-size: 16px;
    font-weight: 500;
    line-height: 19px;
  }
}
</style>
